import { Component } from "@angular/core";

@Component({
  selector: "meet-the-team",
  templateUrl: "./meet-the-team.component.html",
  styleUrls: ["../../styles.marketing247.css"],
})
export class MeetTheTeamComponent {}
